<div class="ion-padding container-flex">
  <div class="header">
    <h3 class="title">
      Thank you for <br />
      using the GoSpread app.
    </h3>
    <p>
      Find below some information about your account.
    </p>
  </div>

  <ion-card color="light">
    <ion-card-header>
      <!-- <ion-img src="assets/money.svg" class="ico" /> -->
      <div style="display: flex; flex-direction: row;">
        <ion-icon name="cash"></ion-icon>
        <ion-card-title>Amount to be paid to the platform for this trip - <small>{{race.porcentagem}}
            cut</small></ion-card-title>
      </div>

    </ion-card-header>
    <ion-card-content style="color: black;">
      {{ saldoCorrida.valorMotorista | currency }}
    </ion-card-content>
  </ion-card>

  <ion-card color="light">
    <ion-card-header>
      <div style="display: flex; flex-direction: row;">
        <ion-icon name="wallet"></ion-icon>
        <ion-card-title>Total Pending Amount- <small>{{race.porcentagem}} cut</small></ion-card-title>
      </div>
    </ion-card-header>
    <ion-card-content>
      {{ saldo.saldoEmAberto | currency }}
    </ion-card-content>
  </ion-card>
  <button class="button-bigger ew" (click)="backQueue()">Back to Line</button>
</div>